// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__QCr4b","title":"Header_title__RFEfW","left":"Header_left__Pk6lx","clinicName":"Header_clinicName__2sUeA"};